import type { User } from "../store/v2/currentUser/selectors";

export function transformUserData(user: User) {
  if (user.phones.length) {
    user.phones.forEach((phone) => {
      if (phone.type === "work") {
        user.workPhone = phone;
      }

      if (phone.type === "cell") {
        user.cellPhone = phone;
      }
    });
  }

  if (!user.workPhone) {
    user.workPhone = {
      code: "+1",
      iso: "US",
      number: "",
    };
  }

  if (!user.cellPhone) {
    user.cellPhone = {
      code: "+1",
      iso: "US",
      number: "",
    };
  }

  return user;
}

export const getInitialsFromName = (name: string) => {
  const initialsRegex = name.match(/\b\w/g) || [];
  return ((initialsRegex.shift() || "") + (initialsRegex.pop() || "")).toUpperCase();
};
